export const HIDDEN_DEFAULT_CLIENTS_LIST_PLAN_PRICE = 99;

export const hasHiddenDefaultClientsListPlanPrice = (advertiserData = {}) =>
  Number(advertiserData?.subscriptionPlanInfo?.price) ===
  HIDDEN_DEFAULT_CLIENTS_LIST_PLAN_PRICE;
